import { toFormData } from 'admin/utils';
import { throwOnError } from './utils';

export type OAuthClientRow = {
  id: string;
  name: string;
  organization: { name: string };
  allowed_grant_types: string[];
  default_scopes: string[];
  created_at: string;
  updated_at: string;
};

export type OAuthClientsPagination = {
  current: number;
  max_page: number;
  has_prev?: boolean;
  has_next?: boolean;
  per_page?: number;
};

export type OAuthClientsListResponse = {
  rows: OAuthClientRow[];
  count: number;
  pagination: OAuthClientsPagination;
};

export const createOAuthClient = (params: Record<string, unknown> = {}) =>
  fetch('/api/oauth-clients', {
    method: 'POST',
    credentials: 'same-origin',
    body: toFormData(params),
  }).then(throwOnError);

export const fetchOAuthClients = (query = '') =>
  fetch(`/api/oauth-clients?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<OAuthClientsListResponse>);

export const fetchOAuthClient = (id: string) =>
  fetch(`/api/oauth-clients/${id}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError);

export const updateOAuthClient = (id: string, params: Record<string, unknown> = {}) =>
  fetch(`/api/oauth-clients/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    body: toFormData(params),
  }).then(throwOnError);
